import gold_token from "../../assets/images/gold_token.png"
import silver_token from "../../assets/images/silver_token.png"
import platinum_token from "../../assets/images/platinum_token.png"
// import tkn_sports_logo from "../../assets/svgs/tkn_sports_logo.svg"
import tkn_sports_logo from "../../assets/images/tkn-logo.png"
import login_bonus from '../../assets/svgs/login_bonus.svg';
import poll_participation from '../../assets/svgs/poll_participation.svg';
import upload_media from '../../assets/svgs/media_upload_bonus_activity.svg';
import add_message from '../../assets/svgs/add_message.svg';

export const APP_NAME = "TKN Sports"

export const APP_NAME_SHORT = "TKN Sports"

export const APP_LOGO_IMAGE = tkn_sports_logo

export const COURT_NAME = "Basketball Stadium"

export const AUTHENTICATION_METHOD = {
    OTP: 1,
    PASSWORD: 2,
    GOOGLE: 3,
}

export const VIA_EMAIL = {
    EMAIL: 1,
    PHONE_NUMBER: 0
}

export const PURCHASE_TYPE = {
    SEASON: "1",
    MATCH: "2"
}

export const PAYMENT_METHOD_TYPE = {
    STRIPE: "1",
    PAYPAL: "2"
}

export const POLL_TYPES = {
    SINGLE: 1,
    MULTIPLE: 2
}

export const POLL_VOTEDFOR = {
    SEASON: 1,
    GAME: 2
}

export const FETCH_POLL_TYPE = {
    LIVE_GAME: 1,
    CURRENT_POLLS: 2,
    PREVIOUS_POLLS: 3
}

export const ZoneColorByCategory = (zoneCat) => {
    switch(zoneCat) {
        case "1":
            return "#B2A5FF"
        case "2":
            return "#FC780B"
        case "3":
            return "#99C9FF"
        default:
            return "#B2A5FF"
    }
}

export const TOKEN_AVAILABILITY_STATUS = {
	AVAILABLE: 1,
	UNAVAILABLE: 2,
	BLOCKED: 3,
	PARTIAL_BLOCKED: 4,
	BOOKED: 5,
	PARTIAL_BOOKED: 6,
}

export const filterString = (str, length=15) => {
    return str?.length > length ? str?.substring(0, length-3) + "..." : str
}

export const getFirstCharUpperCase = (name) => {
    return name?.trim()?.charAt(0).toUpperCase() || '';
  };

// export const zoneImages = {
//     Platinum: platinum_token,
//     Gold: gold_token,
//     Silver: silver_token,
// };

export const zoneImages = {
    Platinum: platinum_token,
    Gold: silver_token,
    Silver: gold_token,
};

export const PAYMENT_STATUS = {
    SUCCEDED: "1",
    FAILED: "0",
}  

export const GENDER = {
    MALE: 1,
    FEMALE: 2,
    OTHER: 3,
  };

export const BONUS_CLAIM_TYPE = {
    SINGLE: 1,
    ALL: 2
}

export const REGEX = {
    DIGITS: /[0-9]/,
    ALPHABETS: /[a-zA-Z]/,
    LOWERCASE_ALPHABETS: /[a-z]/,
    UPPERCASE_ALPHABETS: /[A-Z]/,
    SPECIAL_CHARACTERS: /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
}

export const LIVE_GAME_CHAT_CONTENT_TYPE = {
    TEXT: 1,
    IMAGE: 2,
    VIDEO: 3,
    COMMENTARY: 4,
    MEDIA: 5,
    BOTH_TEXT_MEDIA: 6
}

export const MAX_MEDIA_UPLOAD_LIMIT = 10; //Maximum  no. of files to be uploaded
export const MAX_IMAGE_SIZE_IN_MB = 10 // Maximum size allowed for images (in MB)
export const MAX_VIDEO_SIZE_IN_MB = 30 // Maximum size allowed for videos (in MB)

export const LIVE_GAME_MEDIA_FILTERS = {
    IMAGE: 1,
    VIDEO: 2,
    ALL: 3,
    MY_MEDIA: 4
}

export const RECORD_STATUS = {
    DRAFT: -1,
    INACTIVE: 0,
    ACTIVE: 1,
}

export const getRandomColor = (letter) => {
    const colors = [
      "#FF5733", "#33FF57", "#3357FF", "#F1C40F", "#9B59B6",
      "#1ABC9C", "#E74C3C", "#34495E", "#2ECC71", "#3498DB"
    ];
    const charCode = letter?.toUpperCase().charCodeAt(0) || 0;
    // Map letters A-Z to the colors array
    return colors[charCode % colors.length];
};

export const POWER_UP_FLAG = {
    CANT_POWER_UP: 1,
    NOT_POWERED_UP: 2,
    POWERED_UP: 3,
};

export const RESEND_OTP_DURATION = 30

export const MAX_PLAYERS_PER_TEAM = 5
  
export const Twitter = "https://twitter.com"

export const Facebook = "https://facebook.com"

export const Instagram = "https://instagram.com"

export const Mail = "support@tknsports.com"

export const Phone = "1-800-1234-567"

export const CompanyName = "TKN SPORTS"

export const WEB_URL = "https://bigeast.tknsports.com"

export const MAX_TOKENS_TO_BUY = "20"

export const MAX_TOKEN_BUY_NOTE = `Note:  Select up to ${MAX_TOKENS_TO_BUY} tokens from any available zone`


const ACTIVITY_TYPE = {
    REGISTER: 1,
    LOGIN: 2,
    POLLS: 3,
    SCORER: 4,
    UPLOAD_MEDIA_IN_LIVE_GAME: 5,
    ADD_MESSAGE_IN_LIVE_GAME: 6
}
export const getActivityTypeImage = (activityTypeId) => {
    switch (activityTypeId) {
      case ACTIVITY_TYPE.LOGIN:
        return login_bonus;
      case ACTIVITY_TYPE.POLLS:
        return poll_participation;
      case ACTIVITY_TYPE.UPLOAD_MEDIA_IN_LIVE_GAME:
        return upload_media;
      case ACTIVITY_TYPE.ADD_MESSAGE_IN_LIVE_GAME:
        return add_message;
      default:
        return login_bonus;
    }
};

export const POLL_DISPLAY_TYPE = {
    SEASON: 1,
    GAME: 2,
    BOTH: 3
}